export const isLiveBlogPath = (path) => {
  if (!path) return false;

  return path.split('/')[3] === 'live-blog';
};

/**
 * @param  {String} subType
 * @return {Boolean}
 */
export const shouldRenderRegularBlog = (subType) => subType && subType === 'blog';

export const isSingleCardRoute = (path) => /ncrd\d+$/.test(path);

export const isBlogEventEnded = (flag) => !!flag && typeof flag === 'string' && flag.toLowerCase() === 'event ended';

export const isBlogLive = (dateVal) => (dateVal
  && (Date.now() - (new Date(dateVal)).getTime()) < (129600 * 1000));

export default {
  isLiveBlogPath,
  isSingleCardRoute,
  isBlogEventEnded,
  isBlogLive,
};
